import { FormattedDateTime } from '@elotech/components';

export type LeftComponentProps = {
  dateTime: string;
};

export const LeftComponent = (props: LeftComponentProps) => {
  const { dateTime } = props;

  return <FormattedDateTime value={dateTime} />;
};
